import { StorageService } from './storage.service';

/**
 * Factory function used as an APP_INITIALIZER in `AppModule` so the app
 * awaits Ionic Storage readiness *before* it bootstraps the first
 * guarded route. Without this, any `getItem`/`setItem` call racing the
 * Storage.create() promise would fall through the legacy "init() on
 * miss" path that re-created the underlying DB on every storage op
 * (P0.8 in the refactoring plan).
 */
export function initializeStorage(storageService: StorageService): () => Promise<void> {
    return () => storageService.init();
}
